module.exports = __webpack_public_path__ + "img/logo_koica@3x.10defa0e.png";